import { render, staticRenderFns } from "./SinistersList.vue?vue&type=template&id=45a252b8&scoped=true"
import script from "./SinistersList.vue?vue&type=script&lang=ts"
export * from "./SinistersList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a252b8",
  null
  
)

export default component.exports